import { RECENTLY_SEARCHED_LOCALITIES_RECORD } from 'shared-constants/src/recentlySearchedLocalitiesRecord';

import { getItem, setItem } from '../localStorage';

export default (item) => {
  const data = getItem(RECENTLY_SEARCHED_LOCALITIES_RECORD) || [];
  let noDuplicates = [...data];
  item.forEach((loc) => {
    noDuplicates = noDuplicates.filter((recent) => recent.hkey !== loc.hkey);
  });
  setItem(RECENTLY_SEARCHED_LOCALITIES_RECORD, [...item, ...noDuplicates]);
};
